import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { TableModule } from 'src/app/table/table.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { TenantScheduleComponent } from './tenant-schedule.component';
import { TenantScheduleRoutingModule } from './tenant-schedule-routing.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {DropdownFilterModule} from 'src/app/components/dropdown-fliter/dropdown-filter.module';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SubscriptionTenantModule } from '../subscription-tenant/subscription-tenant.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { TenantCreateScheduleComponent } from './tenant-create-schedule/tenant-create-schedule.component';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PermissionDialogModule } from 'src/app/components/permission-dialog/permission-dialog.module';

@NgModule({
  declarations: [
    TenantScheduleComponent,
    TenantCreateScheduleComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    BreadcrumbModule,
    TableModule,
    PaginatorModule,
    MatProgressSpinnerModule,
    TenantScheduleRoutingModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    DefaultFilterModule,
    MatProgressBarModule,
    SubscriptionTenantModule,
    NgxSkeletonLoaderModule,
    PageLoaderModule,
    PipesModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTableModule,
    SearchFilterModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DatepickerModule,
    MatInputModule,
    ErrorModule,
    MatSlideToggleModule,
    PermissionDialogModule
  ]
})
export class TenantScheduleModule { }